/**
 * The over-length message for form fields without bespoke copy.
 *
 * It is zod 3's default wording, written out because zod 4 rewords its
 * defaults ("Too big: expected string to have <=200 characters") and these
 * fields show the message to operators: inputs without `maxLength`, and
 * CSV-imported batch rows that never pass through an input at all.
 */
export function tooLong(limit: number): string {
  return `String must contain at most ${limit} character(s)`
}
